import React, { ChangeEvent, useState } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { BackendContext } from "../services/backend-context";
import styles from "./App.module.css";
import { NotesView } from "./notes-view/NotesView";
import { RegisterView } from "./register/RegisterView";
import { SignInView } from "./sign-in/SignInView";

const defaultBackend = process.env.REACT_APP_BACKEND_URL!;
const localStorageKey = "secret-notes.backend"

export function App() {
    const [backend, setBackend] = useState(localStorage.getItem(localStorageKey) || defaultBackend);

    const onUpdateBackend = (e: ChangeEvent<HTMLInputElement>) => {
        const updated = e.currentTarget.value;
        localStorage.setItem(localStorageKey, updated);
        setBackend(updated);
    }

    return (
        <BackendContext.Provider value={ { backend: backend || defaultBackend } }>
            <div className={ styles.container }>
                <Router>
                    <Switch>
                        <Route path="/:userId/notes">
                            <NotesView />
                        </Route>
                        <Route path="/sign-in">
                            <SignInView />
                        </Route>
                        <Route path="/register">
                            <RegisterView />
                        </Route>
                        <Route path="">
                            <Redirect to="/sign-in"></Redirect>
                        </Route>
                    </Switch>
                </Router>
                <div className={ styles.backendUrl }>
                    <label>
                        Backend URL:
                        <input type="input" value={ backend } 
                                onChange={ onUpdateBackend } />
                    </label>
                </div>
            </div>
        </BackendContext.Provider>
    )
}

